import Drawable from '../../entities/Drawable.js';
import { imageStore } from '../../images.js';
import Sprite from '../Sprite.js';

export class PartySummaryPokeball extends Drawable {
    constructor(partySummary, pokemon, index) {
        super();
        this.partySummary = partySummary;
        this.pokemon = pokemon;
        this.index = index;
        this.position = { x: 240, y: 0 };
        this.sprite = new Sprite({
            image: imageStore.get('img/party_summary_pokeball.png'),
            position: this.position,
            moving: false,
            visible: true,
            frames: { val: 0, max: 4 },
        });
    }

    getFrame() {
        if (this.pokemon === null) {
            return 0;
        }
        if (this.pokemon.stats.hp === 0) {
            return 2;
        }
        if (this.pokemon.status1 !== null && this.pokemon.status1 !== undefined) {
            return 3;
        }
        return 1;
    }

    draw() {
        this.sprite.frames.val = this.getFrame();
        this.sprite.position = this.position;
        this.sprite.draw();
    }
}

export class FoePartySummary extends Drawable {
    constructor(party = []) {
        super();
        this.party = party;
        this.position = { x: -240, y: 32 };
        this.sprite = new Sprite({
            image: imageStore.get('img/foe_trainer_party_summary.png'),
            position: this.position,
            moving: false,
            visible: true,
            frames: { val: 0, max: 1 },
        });
        this.pokeballs = Array.from({ length: 6 }, (_, i) => {
            const pokemon = i < this.party.length ? this.party[i] : null;
            return new PartySummaryPokeball(this, pokemon, i);
        });
    }

    setParty(party) {
        this.party = party;
        this.pokeballs = Array.from({ length: 6 }, (_, i) => {
            const pokemon = i < this.party.length ? this.party[i] : null;
            return new PartySummaryPokeball(this, pokemon, i);
        });
        console.log('party was set');
    }

    draw() {
        this.sprite.position.x = this.position.x;
        this.sprite.position.y = this.position.y;
        this.sprite.draw();
        this.pokeballs.forEach((pb) => pb.draw());
    }
}

export class PlayerPartySummary extends Drawable {
    constructor(party = []) {
        super();
        this.party = party;
        this.position = { x: 240, y: 88 };
        this.sprite = new Sprite({
            image: imageStore.get('img/player_party_summary.png'),
            position: this.position,
            moving: false,
            visible: true,
            frames: { val: 0, max: 1 },
        });
        this.pokeballs = Array.from({ length: 6 }, (_, i) => {
            const pokemon = i < this.party.length ? this.party[i] : null;
            return new PartySummaryPokeball(this, pokemon, i);
        });
    }

    setParty(party) {
        this.party = party;
        this.pokeballs = Array.from({ length: 6 }, (_, i) => {
            const pokemon = i < this.party.length ? this.party[i] : null;
            return new PartySummaryPokeball(this, pokemon, i);
        });
    }

    draw() {
        this.sprite.position.x = this.position.x;
        this.sprite.position.y = this.position.y;
        this.sprite.draw();
        this.pokeballs.forEach((pb) => pb.draw());
    }
}
